import { render, staticRenderFns } from "./SuppEditAppr.vue?vue&type=template&id=cdcc50b0&scoped=true&"
import script from "./SuppEditAppr.vue?vue&type=script&lang=js&"
export * from "./SuppEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcc50b0",
  null
  
)

export default component.exports